<template>
    <v-dialog
        v-model="dialog"
        max-width="500px"
    >
        <v-card>
            <v-toolbar color="#313a46">
                <v-card-title class="text-h5 white--text">
                {{ formChannel.id ? 'Editar Canal' : 'Adicionar Canal' }}
                </v-card-title>
            </v-toolbar>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="formChannel.id_channel"
                                label="Channel ID"
                                outlined
                                clearable
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="formChannel.name"
                                label="Nome"
                                outlined
                                clearable
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                v-model="formChannel.type"
                                :items="typeOptions"
                                label="Tipo"
                                outlined
                                clearable
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="red darken-1"
                    dark
                    text
                    @click="closeDialog"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    color="#313a46"
                    dark
                    text
                    @click="formChannel.id ? updateChannel(formChannel) : saveChannel(formChannel)"
                >
                    {{ formChannel.id ? 'Atualizar' : 'Salvar' }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: "FormChannels",
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        channel: {
            type: Object,
            default: null,
        },
    },
    data: () => ({
        formChannel: {
            id_channel: "",
            name: "",
            type: "",
        },
        typeOptions: [
            { text: "Grupo", value: "group" },
            { text: "Usuário", value: "user" },
        ],
    }),

    watch: {
        channel: {
            handler(newValue) {
                this.formChannel = newValue;
            },
        },
    },

    methods: {
        closeDialog() {
            this.formChannel = {
                id_channel: "",
                name: "",
            };
            this.$emit("close");
        },
        async saveChannel() {
            this.$emit("save", this.formChannel);
            this.closeDialog()
            this.formChannel = {
                id_channel: "",
                name: "",
                type: "",
            };
        },
        async updateChannel() {
            this.$emit("update", this.formChannel);
            this.closeDialog()
            this.formChannel = {
                id_channel: "",
                name: "",
                type: "",
            };
        },
    },
}
</script>